<script setup lang="ts">
import { AccordionRoot } from "reka-ui";
</script>

<template>
  <AccordionRoot class="divide-y-2 divide-primary border-y-2 border-primary">
    <slot />
  </AccordionRoot>
</template>
